(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[817],{

/***/ 59937:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/independent-travel-agent",
      function () {
        return __webpack_require__(32271);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Switch; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/Switch/Switch.js
var Switch = __webpack_require__(72852);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
;// CONCATENATED MODULE: ./components/Switch/Switch.tsx



var Switch_Switch = (0,styled/* default */.ZP)(Switch/* default */.Z, {
    shouldForwardProp: function() {
        return true;
    }
})(function(param) {
    var switchType = param.switchType, theme = param.theme;
    if (switchType === "ios") {
        return {
            width: 42,
            height: 20,
            padding: 0,
            "& .MuiSwitch-switchBase": {
                padding: 0,
                margin: 1,
                transitionDuration: "300ms",
                "&.Mui-checked": {
                    transform: "translateX(16px)",
                    color: "#fff",
                    "& + .MuiSwitch-track": {
                        backgroundColor: constants/* colorConstants.brandColor */.Q_.brandColor,
                        opacity: 1,
                        border: 0
                    },
                    "&.Mui-disabled + .MuiSwitch-track": {
                        opacity: 0.5
                    }
                },
                "&.Mui-focusVisible .MuiSwitch-thumb": {
                    color: "#33cf4d",
                    border: "6px solid #fff"
                },
                "&.Mui-disabled .MuiSwitch-thumb": {
                    color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]
                },
                "&.Mui-disabled + .MuiSwitch-track": {
                    opacity: theme.palette.mode === "light" ? 0.7 : 0.3
                }
            },
            "& .MuiSwitch-thumb": {
                boxSizing: "border-box",
                width: 22,
                height: 20
            },
            "& .MuiSwitch-track": {
                borderRadius: 26 / 2,
                backgroundColor: constants/* colorConstants.lightGray */.Q_.lightGray,
                opacity: 1,
                transition: theme.transitions.create([
                    "background-color"
                ], {
                    duration: 200
                })
            }
        };
    }
});
/* harmony default export */ var components_Switch_Switch = (Switch_Switch);

;// CONCATENATED MODULE: ./components/Switch/index.ts

/* harmony default export */ var components_Switch = (components_Switch_Switch);


/***/ }),

/***/ 32271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ independent_travel_agent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./blocks/DownloadApp/DownloadApp.tsx + 2 modules
var DownloadApp = __webpack_require__(31968);
// EXTERNAL MODULE: ./blocks/Layouts/GlobalLayout.tsx + 3 modules
var GlobalLayout = __webpack_require__(94082);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./blocks/MylerSection/assets/myler-cover.jpeg
/* harmony default export */ var myler_cover = ({"src":"/_next/static/media/myler-cover.1360140c.jpeg","height":1250,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAbEAACAgMBAAAAAAAAAAAAAAABAgAEAwYisf/EABUBAQEAAAAAAAAAAAAAAAAAAAME/8QAGBEBAQADAAAAAAAAAAAAAAAAAQAREiH/2gAMAwEAAhEDEQA/AJtLb7NZAqVsTMQO2AJ8iIkgbdZhxf/Z","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./components/text/index.ts
var components_text = __webpack_require__(22538);
;// CONCATENATED MODULE: ./blocks/MylerSection/contants.ts

var NavMenus = [
    "About",
    "Why MyLER",
    "Enquire",
    "FAQs"
];
var MylerTools = [
    {
        name: "Technology ",
        description: "Our cutting-edge technology equips you with tools designed to increase efficiency and scalability, whilst streamlining your business processes, freeing up your time to focus on creativity, learning, and delivering outstanding service."
    },
    {
        name: "Knowledge",
        description: "Through our comprehensive tutorials, virtual and in-person training sessions, detailed onboarding, ongoing support, and extensive product insights, you'll be equipped with the expertise and confidence needed to excel with your clients."
    },
    {
        name: "Relationships",
        description: "With over a decade of experience, we’ve built exceptional partnerships with over 5,000 luxury hotels and travel suppliers, whilst cultivating a supportive community among MyLERs, ensuring you thrive within our network."
    }, 
];
var MylerResources = [
    {
        name: "Booking platform",
        blocks: [
            "Our fully GDS-integrated booking platform allows you to search and book effortlessly, whether on our app or website. Accessible via laptop, phone, or tablet, it offers the flexibility to manage your business seamlessly—anytime, anywhere.", 
        ]
    },
    {
        name: "Comprehensive content",
        blocks: [
            "Dive into detailed hotel and room information, from floorplans and videos to Instagram integrations, fun facts, and USPs. This rich content ensures you deliver bespoke recommendations, perfectly tailored to your clients’ needs.", 
        ]
    },
    {
        name: "Consortia",
        blocks: [
            "We’re proud members of Virtuoso, granting you access to elite offers and VIP benefits at over 2,000 luxury providers worldwide. From iconic hotels to cruise lines, tour operators and more, this partnership ensures you can offer your clients unforgettable experiences.", 
        ]
    },
    {
        name: "Commissions",
        blocks: [
            "Stay informed with estimated earnings visible on every booking, so that you know exactly what you’ll earn. Our intuitive dashboard provides a clear view of what you’ve earned, due payments and pipeline. Plus, we handle commission collection for you, with seamless monthly payments.", 
        ]
    },
    {
        name: "Industry access",
        blocks: [
            "Meet and exceed our thresholds to unlock invitations to prestigious industry events, trade shows, and familiarisation trips. You’ll also enjoy MyLER-specific incentives, recognising and rewarding your hard work, whilst fostering growth and expanding your luxury travel network.", 
        ]
    },
    {
        name: "Community",
        blocks: [
            "Benefit from a dedicated community manager to guide your onboarding, training, and professional development. Whether answering questions or sharing insights, they’ll help you maximize your potential.", 
        ]
    },
    {
        name: "Little Black Book",
        blocks: [
            "Our dynamic directory features a range of travel suppliers, resources and contacts utilising our dynamic search for you to find what you need in one place. With this at your fingertips, securing bookings and connecting with key contacts has never been easier.", 
        ]
    },
    {
        name: "Marketing toolkit",
        blocks: [
            "Elevate your brand with our MyLER marketing toolkit, designed to help you create branded proposals, access premium content, and leverage a library of social media assets to effectively promote your business.", 
        ]
    }, 
];
var MylerTestimonials = [
    {
        name: "Annabelle",
        tier: "MyLER",
        year: "2022",
        testimonial: [
            "I have been a MyLER for 18 months and it’s been the perfect job for me, giving me the autonomy to work at times and days that are convenient for me. One of the best parts has been getting to know the Little Emperors team, every single member of which will go above and beyond to help you achieve your potential. Their platform is so simple to use and there is always someone willing to assist if you need help.",
            "I feel so lucky to be a MyLER as it’s truly a welcoming and wonderful company in so many ways. Rebecca is a natural leader, driving Little Emperors and harvesting a community spirit among the entire team. I’m excited to watch the company continue to grow as they have so many amazing new developments coming soon. I have no doubt Little Emperors will be the only place you’ll want to go to book your next holiday.", 
        ]
    },
    {
        name: "Stefan",
        tier: "MyLER",
        year: "2022",
        testimonial: [
            "The Little Emperors Myler’s platform is the most forward thinking that I have seen in terms of usability for ICs in the travel industry. It provides a powerful booking tool that allows you to search, book and manage clients reservations efficiently. Their technology is backed up by an expert travel team which are very attentive to helping you achieve the best for your clients when extra support is needed offline. Complimenting their online portal, their app has enabled me to easily send quotes out digitally to clients whilst on the go, freeing up my time that would have initially been spent formatting different quotes manually on just a desktop platform in an office.",
            "Thank you.", 
        ]
    },
    {
        name: "Tristan",
        tier: "MyLER",
        year: "2022",
        testimonial: [
            "Joining LE has been an exceptional experience for me, especially as an American and first time travel advisor. I was searching for a highly boutique and customer-centric company and LE truly delivers. The MyLER IC program is a seamless, technology-driven program with an extensive network of preferred partner hotels, special rates and benefits- all extremely accessible in just a few clicks. The ability to quickly pull organized PDFs for clients on the go has been life changing. The LE team is highly responsive and always looking to add new qualified partners as well as improve upon all aspects of the operation.", 
        ]
    }, 
];
var MylerFAQs = [
    {
        expanded: true,
        title: "What is a MyLER?",
        text: "A MyLER is an Independent Travel Agent powered by Little Emperors. Little\n    Emperors have been in the business for over 13 years, creating proprietary hotel\n    booking technology and the Little Emperors app as well as building key industry relationships.\n    Little Emperors extends its knowledge and tools to a network of Independent Travel\n    Agents, empowering them to earn an income through booking travel."
    },
    {
        expanded: false,
        title: "What’s the difference between Independent Travel Agents, Independent Travel Advisors and MyLERS?",
        text: "They are all different terms for the same thing; an individual who runs their own business booking travel on behalf of others – at Little Emperors, we call them MyLERs. As a MyLER, you get the added perks of being affiliated to Little Emperors, something that not all Independent Travel Agents benefit from."
    },
    {
        expanded: false,
        title: "Will I be an employee of Little Emperors?",
        text: "As an Independent Travel Agent, you won’t be a Little Emperors employee. Instead, you will be operating your own business with Little Emperors as your affiliate partner, giving you maximum control and flexibility."
    },
    {
        expanded: false,
        title: "What does an Independent Travel Advisor do?",
        text: "You’ll build a network of clients and book their travel. Via the Little Emperors app, you’ll have all the information you need to provide detailed proposals within seconds from anywhere in the world and book and manage your client’s trips. You may choose to just book hotel stays, or you may prefer to create whole travel itineraries for your clients."
    },
    {
        expanded: false,
        title: "Where do Independent Travel Agents work from, and how many hours will I work?",
        text: "The beauty of the MyLER programme is everything is online, so you can work from\n    anywhere in the world. As this is your business, you can work whatever hours work\n    for you."
    },
    {
        expanded: false,
        title: "How much money can I earn as an Independent Travel Agent?",
        text: "The sky’s the limit when it comes to an Independent Travel Agents’ income – the\n    more you book, the more you’ll earn. Earnings are not capped, so you can decide\n    how much work you want to do to determine your earnings."
    },
    {
        expanded: false,
        title: "How will I be paid?",
        text: "After your booking has checked out, we will collect the commission payments on your\n    behalf and send you a booking report. We then simply require an invoice from you\n    and once received we will pay you by direct bank transfer."
    },
    {
        expanded: false,
        title: "What are the benefits of being an Independent Travel Agent?",
        text: "As we’ve already mentioned, you have maximum flexibility and full control over your\n    schedule, your earning potential is not capped as an Independent Travel Agent.\n    What we didn’t mention is you’ll also become part of the best industry. You’ll know\n    about the best hotels in the world, network with hoteliers and be able to provide the\n    best hotel perks."
    },
    {
        expanded: false,
        title: "Why MyLER and why Little Emperors?",
        text: "Simply put, we have the best Independent Travel Agent programme out there. Little\n    Emperors tech is unrivalled, providing in one place all the content you need and a\n    seamless booking platform. After 13 years, we have the best relationships with the\n    best hotels ensuring you won’t find our preferential rates and benefits elsewhere and\n    you’ll have access to all the key industry events."
    },
    {
        expanded: false,
        title: "Can Independent Travel Agents use Little Emperors branding?",
        text: "You absolutely can, and you can have a Little Emperors email address too. If you\n    would prefer to use your own brand, we support that too, and you can even attach\n    your own logo to the PDF proposals."
    },
    {
        expanded: false,
        title: "Can I become a MyLER even though I am already an Independent Travel Agent?",
        text: "Absolutely. We love to provide Independent Travel Agents who are already up and\n    running with extra tools to help them grow their business."
    },
    {
        expanded: false,
        title: "Can I only book hotels?",
        text: "While we offer the best hotels and benefits, our 'Little Black Book' provides access to\n    additional preferred travel suppliers, covering flights, cruises, DMCs, and more. You\n    can also use our IATA number to book hotels we don’t work with and still collect\n    commission. We give you access to everything you need to be a full-service\n    Independent Travel Agent."
    },
    {
        expanded: false,
        title: "Do I have to handle payments?",
        text: "Our rates are set up so that the client pays directly to the hotel, meaning you don’t\n    have to collect payment."
    }, 
];
var InformationSourceOptions = [
    {
        name: "Advertisement",
        value: "Advertisement"
    },
    {
        name: "Event or Trade Show",
        value: "Event or Trade Show"
    },
    {
        name: "Internet",
        value: "Internet"
    },
    {
        name: "Referral",
        value: "Referral"
    },
    {
        name: "Social media",
        value: "Social media"
    },
    {
        name: "Travel Forums or Communities",
        value: "Travel Forums or Communities"
    },
    {
        name: "Other",
        value: "Other"
    }, 
];
var IATAOptions = [
    {
        label: "IATA",
        value: "iata"
    },
    {
        label: "TIDS",
        value: "tids"
    }, 
];


// EXTERNAL MODULE: ./components/container/index.ts
var container = __webpack_require__(49985);
;// CONCATENATED MODULE: ./blocks/MylerSection/components/Navigation.tsx




var Navigation = function(param) {
    var scrollToSection = param.scrollToSection;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        className: "nav-section",
        as: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "nav-section__container",
            children: NavMenus.map(function(menu, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "nav-section__title",
                    onClick: function() {
                        return scrollToSection(menu.replace(/\s/g, "-").toLowerCase());
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Body */.uT, {
                            color: "grey-dark",
                            children: [
                                menu,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "nav-section__divider",
                            id: "divider"
                        })
                    ]
                }, index);
            })
        })
    });
};
/* harmony default export */ var components_Navigation = (Navigation);

;// CONCATENATED MODULE: ./blocks/MylerSection/components/About.tsx



var About = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        className: "myler-about-section",
        id: "about",
        as: "section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                as: "h4",
                children: "About MyLER"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "myler-about-section__subtitle",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                    as: "h2",
                    children: "Turning your passion for travel into profit, our tech-savvy platform lets you earn income while booking travel from anywhere, anytime, whilst always reassuringly supported by Little Emperors industry leading professionalism"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "myler-about-section__body",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                    color: "grey-dark",
                    className: "myler-about-section__body__text",
                    children: "Allowing you to earn income and create unforgettable experiences by booking exceptional trips for your clients"
                })
            })
        ]
    });
};
/* harmony default export */ var components_About = (About);

;// CONCATENATED MODULE: ./blocks/MylerSection/icons/ArrowBulletIcon.tsx

var ArrowBullet = function(param) {
    var className = param.className, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "55",
            height: "16",
            viewBox: "0 0 55 16",
            fill: "none",
            className: className,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M54.7071 8.70711C55.0976 8.31658 55.0976 7.68342 54.7071 7.29289L48.3432 0.928932C47.9526 0.538408 47.3195 0.538408 46.9289 0.928932C46.5384 1.31946 46.5384 1.95262 46.9289 2.34315L52.5858 8L46.9289 13.6569C46.5384 14.0474 46.5384 14.6805 46.9289 15.0711C47.3195 15.4616 47.9526 15.4616 48.3432 15.0711L54.7071 8.70711ZM0 9H54V7H0V9Z",
                fill: "#BAA57E"
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "89",
            height: "16",
            viewBox: "0 0 89 16",
            fill: "none",
            className: className,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M88.7071 8.70711C89.0976 8.31658 89.0976 7.68342 88.7071 7.29289L82.3431 0.928932C81.9526 0.538408 81.3195 0.538408 80.9289 0.928932C80.5384 1.31946 80.5384 1.95262 80.9289 2.34315L86.5858 8L80.9289 13.6569C80.5384 14.0474 80.5384 14.6805 80.9289 15.0711C81.3195 15.4616 81.9526 15.4616 82.3431 15.0711L88.7071 8.70711ZM0 9H88V7H0V9Z",
                fill: "#BAA57E"
            })
        })
    });
};
/* harmony default export */ var ArrowBulletIcon = (ArrowBullet);

// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
;// CONCATENATED MODULE: ./blocks/MylerSection/components/Why.tsx







var Why = function(param) {
    var handleOpenEnquiryForm = param.handleOpenEnquiryForm;
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:700px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        className: "why-myler-section",
        as: "section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "why-myler-section__title",
                id: "why-myler",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                    as: "h4",
                    children: "Why MyLER?"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "why-myler-section__subtitle",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                    as: "h5",
                    children: "At the heart of MyLER lie three core pillars:"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "myler-tools",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "myler-tools__container",
                    children: [
                        MylerTools.map(function(tool, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "myler-tools__tool",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "myler-tools__tool-title",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBulletIcon, {
                                                isMobile: isMobile
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Heading */.X6, {
                                                as: "h5",
                                                children: [
                                                    " ",
                                                    tool.name
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "myler-tools__tool-description",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                            color: "grey-dark",
                                            children: tool.description
                                        })
                                    })
                                ]
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "why-myler-section__enquire",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                title: "Enquire",
                                className: "why-myler-section__enquire-button",
                                onClick: function() {
                                    return handleOpenEnquiryForm();
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_Why = (Why);

;// CONCATENATED MODULE: ./blocks/MylerSection/components/Resources.tsx




var Resources = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        className: "myler-resources",
        as: "section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "myler-resources__imageContainer",
                title: "myler benefits cover",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "myler-resources__gradient"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "myler-resources__heading",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                            as: "h4",
                            color: "white",
                            children: "Unlock access to the best resources in the industry to manage your business"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "myler-resources__cardList",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "myler-resources__cardList-wrapper",
                    children: MylerResources.map(function(resource, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "resource-card",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "resource-card__title",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                                        as: "h5",
                                        weight: "demiBold",
                                        color: "grey-dark",
                                        children: resource.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "resource-card__content",
                                    children: resource.blocks.map(function(text, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Body */.uT, {
                                                color: "grey-dark",
                                                children: [
                                                    text,
                                                    " "
                                                ]
                                            })
                                        }, index);
                                    })
                                })
                            ]
                        }, index);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_Resources = (Resources);

;// CONCATENATED MODULE: ./blocks/MylerSection/components/Enquire.tsx




var Enquire = function(param) {
    var handleOpenEnquiryForm = param.handleOpenEnquiryForm;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "enquire-container",
        id: "enquire",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "enquire-container__image-container",
            title: "Cover for learn more about the myler program",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "enquire-container__message-card",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                                as: "h4",
                                children: " Interested in becoming a MyLER?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                mt: 20,
                                color: "grey-dark",
                                children: "Just complete a short form and a member of our team will be in touch with more information"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                        mt: 40,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            title: "Enquire",
                            onClick: function() {
                                return handleOpenEnquiryForm();
                            },
                            className: "btn"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_Enquire = (Enquire);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./blocks/MylerSection/components/Testimonial.module.scss
var Testimonial_module = __webpack_require__(37849);
var Testimonial_module_default = /*#__PURE__*/__webpack_require__.n(Testimonial_module);
// EXTERNAL MODULE: ./node_modules/react-material-ui-carousel/dist/index.js
var dist = __webpack_require__(13056);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./components/icons/index.ts + 18 modules
var icons = __webpack_require__(30918);
;// CONCATENATED MODULE: ./blocks/MylerSection/components/Testimonials.tsx








var Testimonials = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        className: (Testimonial_module_default()).container,
        as: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
            className: (Testimonial_module_default()).wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                    as: "h4",
                    align: "center",
                    children: "MyLER Testimonials"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                    className: (Testimonial_module_default()).questionMark,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* QuotationMark */.Sd, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                    mt: 30,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                        className: (Testimonial_module_default()).carousel,
                        autoPlay: false,
                        animation: "slide",
                        navButtonsAlwaysVisible: true,
                        navButtonsWrapperProps: {
                            className: (Testimonial_module_default()).navPosition
                        },
                        NextIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Testimonial_module_default()).rightArrow,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowRight */.ol, {})
                        }),
                        PrevIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Testimonial_module_default()).leftArrow,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowLeft */.Xd, {})
                        }),
                        indicators: false,
                        height: 425,
                        navButtonsProps: {
                            style: {
                                backgroundColor: "transparent",
                                borderRadius: 0
                            }
                        },
                        children: MylerTestimonials.map(function(item, i) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(container/* default */.Z, {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                                        className: (Testimonial_module_default()).testimonialWrapper,
                                        children: (ref = item.testimonial) === null || ref === void 0 ? void 0 : ref.map(function(text, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                                className: (Testimonial_module_default()).testimonial,
                                                children: text
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
                                        className: (Testimonial_module_default()).testimonialName,
                                        mt: 30,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                                className: (Testimonial_module_default()).name,
                                                weight: "demiBold",
                                                color: "grey-dark",
                                                children: item.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Body */.uT, {
                                                className: (Testimonial_module_default()).tier,
                                                weight: "demiBold",
                                                color: "grey-dark",
                                                children: [
                                                    item.tier,
                                                    " since ",
                                                    item.year
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, i);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_Testimonials = (Testimonials);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./blocks/MylerSection/components/Faq.module.scss
var Faq_module = __webpack_require__(78863);
var Faq_module_default = /*#__PURE__*/__webpack_require__.n(Faq_module);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js
var Accordion = __webpack_require__(86532);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js
var AccordionDetails = __webpack_require__(63083);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(61250);
// EXTERNAL MODULE: ./components/icons/ArrowUp.tsx
var ArrowUp = __webpack_require__(29661);
// EXTERNAL MODULE: ./components/icons/ArrowRight.tsx
var ArrowRight = __webpack_require__(10997);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
;// CONCATENATED MODULE: ./blocks/MylerSection/components/FaqAccordion.tsx








var FaqAccordion = function(param) {
    var expanded = param.expanded, handleChange = param.handleChange, title = param.title, text = param.text, id = param.id, sx = param.sx;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
        expanded: expanded,
        disableGutters: true,
        elevation: 0,
        onChange: function() {
            return handleChange(id);
        },
        sx: (0,_object_spread/* default */.Z)({
            border: "none",
            ":before": {
                backgroundColor: constants/* colorConstants.brandColor */.Q_.brandColor
            }
        }, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                "aria-controls": "".concat(id),
                id: "".concat(id),
                expandIcon: expanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {}),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "faq-title",
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "accordion-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "accordion-container__left",
                        children: text && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "accordion-content",
                            children: text
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_FaqAccordion = (FaqAccordion);

;// CONCATENATED MODULE: ./blocks/MylerSection/components/Faq.tsx









var LastFAQ = function(handleClick) {
    return {
        expanded: false,
        title: "How do I become a MyLER?",
        text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                "Just complete our form",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Faq_module_default()).enquiryFormLink,
                    onClick: handleClick,
                    children: "here"
                }),
                " ",
                "to let us know you’d like to become an Independent Travel Agent and a member of our team will be in touch."
            ]
        })
    };
};
var Faq = function(param) {
    var handleOpenEnquiryForm = param.handleOpenEnquiryForm;
    var ref = (0,react.useState)(null), expandedPanelId = ref[0], setExpandedPanelId = ref[1];
    var lastFAQ = LastFAQ(handleOpenEnquiryForm);
    var handleAccordionChange = (0,react.useCallback)(function(id) {
        if (expandedPanelId !== null && expandedPanelId === id) {
            setExpandedPanelId(null);
        } else {
            setExpandedPanelId(id);
        }
    }, [
        expandedPanelId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        className: (Faq_module_default()).container,
        id: "faqs",
        as: "section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                as: "h4",
                align: "center",
                children: "FAQs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                className: (Faq_module_default()).faqList,
                children: (0,_to_consumable_array/* default */.Z)(MylerFAQs).concat([
                    lastFAQ
                ]).map(function(faq, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqAccordion, {
                        title: faq.title,
                        text: faq.text,
                        expanded: expandedPanelId === index.toString(),
                        id: index.toString(),
                        handleChange: handleAccordionChange,
                        sx: {
                            borderBottom: 1,
                            borderColor: constants/* colorConstants.brandColor */.Q_.brandColor,
                            "& .MuiAccordionSummary-content": {
                                fontWeight: 500
                            }
                        }
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var components_Faq = (Faq);

// EXTERNAL MODULE: ./components/HotelsCarousel/HotelsCarousel.tsx + 22 modules
var HotelsCarousel = __webpack_require__(95102);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./data/translationKeys.ts
var translationKeys = __webpack_require__(698);
// EXTERNAL MODULE: ./customHooks/useLocalised/useLocalised.ts + 2 modules
var useLocalised = __webpack_require__(91933);
;// CONCATENATED MODULE: ./blocks/MylerSection/components/Hotels.tsx









var Hotels = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:650px)");
    var our_hotels_text = (0,useLocalised/* default */.Z)(translationKeys.our_hotels);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        className: "hotels-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelsCarousel/* default */.Z, {
                showControlls: isMobile ? false : true,
                className: "hotels-container__hotel-carousel"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hotels-container__explore",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: constants/* navigationPaths.OUR_HOTELS */.aY.OUR_HOTELS,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        "area-label": our_hotels_text,
                        className: "linkButton",
                        target: "_blank",
                        children: "Explore"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_Hotels = (Hotels);

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(58081);
// EXTERNAL MODULE: ./api/api.ts
var api_api = __webpack_require__(77907);
;// CONCATENATED MODULE: ./api/mylers/leads.ts




var createMylerLead = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(payload) {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api/* default.post */.ZP.post("/ics/leads/", payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function createMylerLead(payload) {
        return _ref.apply(this, arguments);
    };
}();
var getReferralChannels = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api_api/* default.get */.Z.get("/ics/referral-channels")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getReferralChannels() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./api/mylers/index.ts


// EXTERNAL MODULE: ./blocks/MylerSection/enquiry-form/EnquiryForm.module.scss
var EnquiryForm_module = __webpack_require__(49323);
var EnquiryForm_module_default = /*#__PURE__*/__webpack_require__.n(EnquiryForm_module);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(64666);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(35713);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./components/TextField/ControlledTextField.tsx
var ControlledTextField = __webpack_require__(17073);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/zod/v3/types.js + 4 modules
var types = __webpack_require__(45901);
// EXTERNAL MODULE: ./node_modules/zod/v3/ZodError.js
var ZodError = __webpack_require__(79711);
;// CONCATENATED MODULE: ./blocks/MylerSection/texts.ts


var translations = (0,useLocalised/* localise */.n)(Object.values(translationKeys).map(function(textKey) {
    return textKey;
}));
/* harmony default export */ var texts = (translations);

// EXTERNAL MODULE: ./utils/schema/zodUtils.ts
var zodUtils = __webpack_require__(28461);
;// CONCATENATED MODULE: ./blocks/MylerSection/enquiry-form/schemas.ts



var enquiryFormSchema = types/* object */.Ry({
    name: types/* string */.Z_().default(""),
    companyName: types/* string */.Z_().optional().default(""),
    email: types/* string */.Z_(),
    phoneNumber: types/* string */.Z_().optional(),
    city: types/* object */.Ry({
        id: types/* number */.Rx().default(0),
        name: types/* string */.Z_().default("")
    }),
    channel: types/* string */.Z_(),
    isProfessional: types/* boolean */.O7().default(false),
    leadSource: types/* string */.Z_().default("website"),
    source: types/* string */.Z_().optional().default(""),
    iataType: types/* string */.Z_().default("iata"),
    enterIataNumber: types/* boolean */.O7().default(false),
    iataNumber: types/* string */.Z_().optional().default(""),
    partnerConsortium: types/* boolean */.O7().optional().default(false),
    partnerConsortiumName: types/* string */.Z_().optional().default(""),
    notes: types/* string */.Z_().optional().default(""),
    referralName: types/* string */.Z_().optional().default(""),
    otherSource: types/* string */.Z_().optional().default("")
}).superRefine(function(data, ctx) {
    var ref;
    if (data.name.length < 1) {
        ctx.addIssue({
            code: ZodError/* ZodIssueCode.custom */.NL.custom,
            path: [
                "name"
            ],
            message: texts.myler_enquiry_form_name_required
        });
    }
    if (data.email.length < 1) {
        ctx.addIssue({
            code: ZodError/* ZodIssueCode.custom */.NL.custom,
            path: [
                "email"
            ],
            message: texts.myler_enquiry_form_valid_email
        });
    }
    if (data.city && !data.city.name || !data.city.id || data.city.id === 0) {
        ctx.addIssue({
            code: ZodError/* ZodIssueCode.custom */.NL.custom,
            path: [
                "city.id"
            ],
            message: texts.cityOfResidence_input_error
        });
    }
    if (data.channel.length < 1) {
        ctx.addIssue({
            code: ZodError/* ZodIssueCode.custom */.NL.custom,
            path: [
                "channel"
            ],
            message: texts.enquiry_form_channel_input_error
        });
    }
    if (data.enterIataNumber && !data.iataType) {
        ctx.addIssue({
            code: ZodError/* ZodIssueCode.custom */.NL.custom,
            path: [
                "iataType"
            ],
            message: "Please select IATA number type"
        });
    }
    if (data.enterIataNumber && data.iataType && !data.iataNumber) {
        ctx.addIssue({
            code: ZodError/* ZodIssueCode.custom */.NL.custom,
            path: [
                "iataNumber"
            ],
            message: "Please enter your ".concat(data.iataType.toUpperCase(), " number")
        });
    }
    if (data.partnerConsortium && !data.partnerConsortiumName) {
        ctx.addIssue({
            code: ZodError/* ZodIssueCode.custom */.NL.custom,
            path: [
                "partnerConsortiumName"
            ],
            message: "Please enter preferred hotel partner program or consortia"
        });
    }
    if (data.channel && ((ref = data.channel) === null || ref === void 0 ? void 0 : ref.split("-")[1].toLowerCase()) === "referral" && !data.referralName) {
        ctx.addIssue({
            code: ZodError/* ZodIssueCode.custom */.NL.custom,
            path: [
                "referralName"
            ],
            message: "Please enter the referral name"
        });
    }
});
var enquiryFormDefault = (0,zodUtils/* getDefaults */.J)(enquiryFormSchema);


// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(56312);
// EXTERNAL MODULE: ./blocks/SearchableField/SearchableFieldContainer.tsx + 2 modules
var SearchableFieldContainer = __webpack_require__(34520);
;// CONCATENATED MODULE: ./blocks/SearchableField/index.ts

/* harmony default export */ var SearchableField = (SearchableFieldContainer/* default */.Z);

// EXTERNAL MODULE: ./api/misc.ts
var misc = __webpack_require__(39844);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./components/RadioButton/ControlledRadioButton.tsx
var ControlledRadioButton = __webpack_require__(46050);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./blocks/MylerSection/components/toggle-input/ToggleInput.module.scss
var ToggleInput_module = __webpack_require__(83901);
var ToggleInput_module_default = /*#__PURE__*/__webpack_require__.n(ToggleInput_module);
// EXTERNAL MODULE: ./components/Switch/index.ts + 1 modules
var Switch = __webpack_require__(30707);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./blocks/MylerSection/components/toggle-input/ToggleInput.tsx








var ToggleInput = function(param) {
    var label = param.label, onChange = param.onChange, children = param.children;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ToggleInput_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ToggleInput_module_default()).headerSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                        weight: "demiBold",
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, {
                        switchType: "ios",
                        label: "text",
                        className: (ToggleInput_module_default())["switch"],
                        onChange: function(event, checked) {
                            setIsOpen(checked);
                            onChange && onChange(event);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((ToggleInput_module_default()).content, (0,_define_property/* default */.Z)({}, (ToggleInput_module_default()).contentOpen, isOpen)),
                children: children
            })
        ]
    });
};
/* harmony default export */ var toggle_input_ToggleInput = (ToggleInput);

;// CONCATENATED MODULE: ./blocks/MylerSection/components/toggle-input/ControlledToggleInput.tsx







var ControlledToggleInput = function(props) {
    var name = props.name, rest = (0,_object_without_properties/* default */.Z)(props, [
        "name"
    ]);
    var control = (0,index_esm/* useFormContext */.Gc)().control;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: name,
        defaultValue: false,
        control: control,
        render: function(param) {
            var onChange = param.field.onChange;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(toggle_input_ToggleInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                onChange: onChange
            }));
        }
    });
};
/* harmony default export */ var toggle_input_ControlledToggleInput = (ControlledToggleInput);

// EXTERNAL MODULE: ./components/Select/ControlledSelect.tsx
var ControlledSelect = __webpack_require__(61339);
// EXTERNAL MODULE: ./blocks/MylerSection/components/referral-channel-select/ReferralChannel.module.scss
var ReferralChannel_module = __webpack_require__(14533);
var ReferralChannel_module_default = /*#__PURE__*/__webpack_require__.n(ReferralChannel_module);
;// CONCATENATED MODULE: ./blocks/MylerSection/components/referral-channel-select/ReferralChannelSelect.tsx




var ReferralChannelSelect = function(param) {
    var label = param.label, name = param.name, _defaultChannel = param.defaultChannel, defaultChannel = _defaultChannel === void 0 ? "" : _defaultChannel, _channels = param.channels, channels = _channels === void 0 ? [] : _channels;
    var formState = (0,index_esm/* useFormContext */.Gc)().formState;
    var error = formState.errors[name];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledSelect/* ControlledSelect */.d, {
                label: label,
                name: name,
                options: channels,
                defaultValue: defaultChannel
            }),
            error && typeof error.message === "string" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (ReferralChannel_module_default()).errorMsg,
                children: error.message
            })
        ]
    });
};
/* harmony default export */ var referral_channel_select_ReferralChannelSelect = (ReferralChannelSelect);

;// CONCATENATED MODULE: ./blocks/MylerSection/components/referral-channel-select/ReferRallChannelSelectContainer.tsx







var ReferralChannelsSelectContainer = function(props) {
    var ref = (0,useQuery/* useQuery */.a)([
        "referralChannels"
    ], function() {
        return getReferralChannels();
    }), referralChannels = ref.data, isLoading = ref.isLoading;
    if (isLoading || !referralChannels) {
        return null;
    }
    var initialOptions = {
        value: "",
        name: "Select channel"
    };
    var transformedOptions = referralChannels.map(function(channel) {
        return {
            value: "".concat(channel.id.toString(), "-").concat(channel.name),
            name: channel.name
        };
    });
    var channelOptions = [
        initialOptions
    ].concat((0,_to_consumable_array/* default */.Z)(transformedOptions));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(referral_channel_select_ReferralChannelSelect, (0,_object_spread/* default */.Z)({
        channels: channelOptions
    }, props));
};
/* harmony default export */ var ReferRallChannelSelectContainer = (ReferralChannelsSelectContainer);

;// CONCATENATED MODULE: ./blocks/MylerSection/components/referral-channel-select/index.tsx


;// CONCATENATED MODULE: ./blocks/MylerSection/enquiry-form/EnquiryForm.tsx


























var EnquiryForm = function(param) {
    var open = param.open, handleFormClose = param.handleFormClose, onSubmitSuccess = param.onSubmitSuccess;
    var ref;
    var nameText = (0,useLocalised/* default */.Z)(translationKeys.name);
    var companyNameText = (0,useLocalised/* default */.Z)(translationKeys.company_name);
    var phoneNumberText = (0,useLocalised/* default */.Z)(translationKeys.phone_number);
    var emailText = (0,useLocalised/* default */.Z)(translationKeys.email);
    var cityOfResidenceText = (0,useLocalised/* default */.Z)(translationKeys.enquiry_form_city_of_residennce);
    var travelProfessionalText = (0,useLocalised/* default */.Z)(translationKeys.enquiry_form_travel_professional_question);
    var channelText = (0,useLocalised/* default */.Z)(translationKeys.how_did_you_hear_about_myler);
    var partnerConsortiumText = (0,useLocalised/* default */.Z)(translationKeys.partner_consortium_question);
    var enquireText = (0,useLocalised/* default */.Z)(translationKeys.enquire);
    var iataNumberQuestionText = (0,useLocalised/* default */.Z)(translationKeys.iata_number_question);
    var methods = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod/* zodResolver */.F)(enquiryFormSchema),
        defaultValues: enquiryFormDefault,
        mode: "onSubmit"
    });
    var handleSubmit = methods.handleSubmit, control = methods.control, setError = methods.setError, reset = methods.reset, clearErrors = methods.clearErrors, trigger = methods.trigger, errors = methods.formState.errors, watch = methods.watch;
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var handleDialogClose = function() {
        reset();
        handleFormClose && handleFormClose();
    };
    var createLeadMutation = (0,useMutation/* useMutation */.D)(function(data) {
        return createMylerLead(data);
    }, {
        onSuccess: function() {
            handleDialogClose();
            onSubmitSuccess();
        },
        onError: function(_) {
            setError("root.requestError", {
                message: ""
            }, {
                shouldFocus: true
            });
        }
    });
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var ref, payload;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setIsLoading(true);
                payload = {
                    city_id: data.city.id,
                    name: data.name,
                    is_professional: data.isProfessional,
                    source: "website",
                    phone_number: data.phoneNumber,
                    email: data.email,
                    company_name: data.companyName,
                    iata_type: data.iataType,
                    iata_number: data.iataNumber,
                    information_source: data.otherSource,
                    additional_comments: data.notes,
                    is_preferred_hotel_partner: !!data.partnerConsortiumName,
                    preferred_hotel_partner_name: data.partnerConsortiumName,
                    referral_channel_type_id: parseInt((ref = data.channel) === null || ref === void 0 ? void 0 : ref.split("-")[0]),
                    referee: data.referralName
                };
                createLeadMutation.mutate(payload, {
                    onSuccess: function() {
                        setIsLoading(false);
                    },
                    onError: function() {
                        setIsLoading(false);
                    }
                });
                return [
                    2
                ];
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var channelValue = watch("channel");
    var channelName = channelValue ? channelValue.split("-")[1].toLowerCase() : "";
    var isReferralSource = channelName === "referral";
    var otherSource = channelName === "other";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        open: open,
        onClose: handleDialogClose,
        className: (EnquiryForm_module_default()).dialog,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
            className: (EnquiryForm_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                    className: (EnquiryForm_module_default()).closeBtnWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        "aria-label": "close",
                        className: (EnquiryForm_module_default()).closeBtn,
                        onClick: handleDialogClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                            className: (EnquiryForm_module_default()).closeIcon
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
                    className: (EnquiryForm_module_default()).headerSection,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                            as: "h4",
                            align: "center",
                            children: "Interested in becoming a MyLER?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                            className: (EnquiryForm_module_default()).subheading,
                            align: "center",
                            children: "Complete a short form and a member of our team will be in touch with more information."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                    className: (EnquiryForm_module_default()).form,
                    as: "form",
                    onChange: function(e) {
                        return clearErrors("root.requestError");
                    },
                    onSubmit: function(e) {
                        return handleSubmit(onSubmit)(e).catch(function(_) {});
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledTextField/* ControlledTextField */.M, {
                                label: nameText,
                                type: "text",
                                name: "name"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledTextField/* ControlledTextField */.M, {
                                label: companyNameText + " (optional)",
                                type: "text",
                                name: "companyName"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledTextField/* ControlledTextField */.M, {
                                label: emailText,
                                type: "email",
                                name: "email"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledTextField/* ControlledTextField */.M, {
                                label: phoneNumberText + " (optional)",
                                type: "text",
                                name: "phoneNumber"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                control: control,
                                defaultValue: {
                                    name: "",
                                    id: 0
                                },
                                name: "city",
                                render: function(param) {
                                    var _field = param.field, onChange = _field.onChange, value = _field.value, ref = _field.ref;
                                    var ref1, ref2, ref3, ref4;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchableField, {
                                        reference: ref,
                                        name: "city",
                                        label: cityOfResidenceText,
                                        queryFunction: misc/* getCityList */.vz,
                                        onChange: onChange,
                                        value: value,
                                        errorMsg: ((ref1 = errors.city) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.name) === null || ref2 === void 0 ? void 0 : ref2.message) || ((ref3 = errors.city) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.id) === null || ref4 === void 0 ? void 0 : ref4.message)
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(toggle_input_ControlledToggleInput, {
                                label: travelProfessionalText,
                                name: "isProfessional"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(toggle_input_ControlledToggleInput, {
                                label: iataNumberQuestionText,
                                name: "enterIataNumber",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledRadioButton/* default */.Z, {
                                        name: "iataType",
                                        options: IATAOptions,
                                        defaultValue: "iata",
                                        defaultChecked: true,
                                        className: (EnquiryForm_module_default()).iataType
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledTextField/* ControlledTextField */.M, {
                                        type: "text",
                                        name: "iataNumber"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(toggle_input_ControlledToggleInput, {
                                label: partnerConsortiumText,
                                name: "partnerConsortium",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledTextField/* ControlledTextField */.M, {
                                    type: "text",
                                    name: "partnerConsortiumName"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReferRallChannelSelectContainer, {
                                label: channelText,
                                name: "channel"
                            }),
                            isReferralSource && /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledTextField/* ControlledTextField */.M, {
                                label: "Referral name",
                                type: "text",
                                name: "referralName"
                            }),
                            otherSource && /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledTextField/* ControlledTextField */.M, {
                                type: "text",
                                name: "otherSource"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledTextField/* ControlledTextField */.M, {
                                label: "Anything else to share with us...",
                                type: "text",
                                name: "notes",
                                multiline: true,
                                minRows: 3
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                                className: (EnquiryForm_module_default()).enquireBtnWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                    htmlAttributes: {
                                        disabled: isLoading
                                    },
                                    title: enquireText,
                                    onClick: function() {},
                                    isLoading: isLoading,
                                    className: (EnquiryForm_module_default()).enquireBtn
                                })
                            }),
                            ((ref = errors.root) === null || ref === void 0 ? void 0 : ref.requestError) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Body */.uT, {
                                color: "forms-red",
                                mt: 10,
                                children: [
                                    "There has been an issue with submitting your enquiry form, please try again or alternatively contact us for assistance",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:myler@littleemperors.com",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "myler@littleemperors.com"
                                    })
                                ]
                            })
                        ]
                    }))
                })
            ]
        })
    });
};
/* harmony default export */ var enquiry_form_EnquiryForm = (EnquiryForm);

;// CONCATENATED MODULE: ./blocks/MylerSection/enquiry-form/EnquiryFormContainer.tsx







var EnquiryFormContainer = function(props) {
    var ref = (0,useQuery/* useQuery */.a)([
        "referralChannels"
    ], function() {
        return getReferralChannels();
    }), referralChannels = ref.data, isLoading = ref.isLoading;
    if (isLoading || !referralChannels) {
        return null;
    }
    var transformedChannelOptions = referralChannels.map(function(channel) {
        return {
            value: "".concat(channel.id.toString(), "-").concat(channel.name),
            name: channel.name
        };
    });
    var initialOptions = {
        value: "",
        name: "Select channel"
    };
    var channelOptionsWithDefault = [
        initialOptions
    ].concat((0,_to_consumable_array/* default */.Z)(transformedChannelOptions));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(enquiry_form_EnquiryForm, (0,_object_spread/* default */.Z)({
        channels: channelOptionsWithDefault
    }, props));
};
/* harmony default export */ var enquiry_form_EnquiryFormContainer = (EnquiryFormContainer);

// EXTERNAL MODULE: ./blocks/MylerSection/components/InfoDialog.module.scss
var InfoDialog_module = __webpack_require__(84135);
var InfoDialog_module_default = /*#__PURE__*/__webpack_require__.n(InfoDialog_module);
;// CONCATENATED MODULE: ./blocks/MylerSection/components/InfoDialog.tsx







var InfoDialog = function(param) {
    var open = param.open, title = param.title, subHeading = param.subHeading, handleClose = param.handleClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        open: open,
        fullWidth: true,
        maxWidth: "sm",
        PaperProps: {
            style: {
                borderRadius: 0
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
            className: (InfoDialog_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                    className: (InfoDialog_module_default()).closeIconWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: handleClose,
                        className: (InfoDialog_module_default()).closeIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LittleEmperorsIcon */.IX, {
                    color: constants/* colorConstants.black */.Q_.black,
                    className: (InfoDialog_module_default()).logo
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                    as: "h4",
                    mt: 15,
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                    className: (InfoDialog_module_default()).subHeading,
                    children: subHeading
                })
            ]
        })
    });
};
/* harmony default export */ var components_InfoDialog = (InfoDialog);

// EXTERNAL MODULE: ./components/container/Container.tsx
var Container = __webpack_require__(93375);
// EXTERNAL MODULE: ./blocks/MylerSection/components/video-player/VideoPlayer.module.scss
var VideoPlayer_module = __webpack_require__(58252);
var VideoPlayer_module_default = /*#__PURE__*/__webpack_require__.n(VideoPlayer_module);
;// CONCATENATED MODULE: ./blocks/MylerSection/icons/PlayButton.tsx

var PlayButton = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Icon Frame",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Play",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.99 11.7773C22.9219 10.8388 22.4205 9.92777 21.4859 9.39398L7.48782 1.39936C5.48785 0.25713 3 1.70127 3 4.00443V19.9937C3 22.2968 5.48785 23.741 7.48781 22.5988L21.4859 14.6041C22.4205 14.0703 22.9219 13.1593 22.99 12.2208C23.0226 12.0751 23.0226 11.9231 22.99 11.7773Z",
                fill: "white"
            })
        })
    });
};
/* harmony default export */ var icons_PlayButton = (PlayButton);

;// CONCATENATED MODULE: ./blocks/MylerSection/icons/Sound.tsx

var Sound = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "Icon Frame",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Ellipse 53",
                    d: "M21.8027 8C21.9334 9.31562 22.0002 10.65 22.0002 12C22.0002 13.35 21.9334 14.6844 21.8027 16",
                    stroke: "white",
                    strokeWidth: "1.5",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Ellipse 52",
                    d: "M17.877 9C17.9586 9.9892 18.0002 10.9897 18.0002 12C18.0002 13.0103 17.9586 14.0108 17.877 15",
                    stroke: "white",
                    strokeWidth: "1.5",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Ellipse 51",
                    d: "M13 12C13 9.45813 12.7849 6.9701 12.373 4.55567C12.2494 3.83122 11.4028 3.51321 10.8175 3.95772L7.53627 6.44984C7.18835 6.71409 6.76348 6.85714 6.3266 6.85714H3C1.89543 6.85714 1 7.75257 1 8.85714V15.1429C1 16.2474 1.89543 17.1429 3 17.1429H6.3266C6.76348 17.1429 7.18835 17.2859 7.53627 17.5502L10.8175 20.0423C11.4027 20.4868 12.2494 20.1688 12.373 19.4443C12.7849 17.0299 13 14.5419 13 12Z",
                    fill: "white",
                    stroke: "white",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
/* harmony default export */ var icons_Sound = (Sound);

// EXTERNAL MODULE: ./components/Button/BaseButton.tsx
var BaseButton = __webpack_require__(26200);
;// CONCATENATED MODULE: ./blocks/MylerSection/icons/Pause.tsx

var Pause = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "20",
        viewBox: "0 0 16 20",
        fill: "none",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.2857 1.11111C10.2857 0.497462 10.7974 0 11.4286 0H14.8571C15.4883 0 16 0.497461 16 1.11111V18.8889C16 19.5025 15.4883 20 14.8571 20H11.4286C10.7974 20 10.2857 19.5025 10.2857 18.8889V1.11111Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 1.11111C0 0.497462 0.511675 0 1.14286 0H4.57143C5.20261 0 5.71429 0.497461 5.71429 1.11111V18.8889C5.71429 19.5025 5.20261 20 4.57143 20H1.14286C0.511675 20 0 19.5025 0 18.8889V1.11111Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var icons_Pause = (Pause);

;// CONCATENATED MODULE: ./blocks/MylerSection/icons/Mute.tsx

var Mute = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 12C13 9.45813 12.7849 6.9701 12.373 4.55567C12.2494 3.83122 11.4028 3.51321 10.8175 3.95772L7.53627 6.44984C7.18835 6.71409 6.76348 6.85714 6.3266 6.85714H3C1.89543 6.85714 1 7.75257 1 8.85714V15.1429C1 16.2474 1.89543 17.1429 3 17.1429H6.3266C6.76348 17.1429 7.18835 17.2859 7.53627 17.5502L10.8175 20.0423C11.4027 20.4868 12.2494 20.1688 12.373 19.4443C12.7849 17.0299 13 14.5419 13 12Z",
                fill: "white",
                stroke: "white",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 9L23 15M17 15L23 9",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var icons_Mute = (Mute);

// EXTERNAL MODULE: ./blocks/MylerSection/components/video-player/ProgressBar.module.scss
var ProgressBar_module = __webpack_require__(85647);
var ProgressBar_module_default = /*#__PURE__*/__webpack_require__.n(ProgressBar_module);
;// CONCATENATED MODULE: ./blocks/MylerSection/components/video-player/ProgressBar.tsx





var ProgressBar = function(_param) {
    var className = _param.className, currentTime = _param.currentTime, _max = _param.max, max = _max === void 0 ? 100 : _max, onSeek = _param.onSeek, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "currentTime",
        "max",
        "onSeek"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
        type: "range",
        className: classnames_default()((ProgressBar_module_default()).range, className),
        value: currentTime,
        max: max,
        style: {
            backgroundSize: "".concat(currentTime, "% 100%")
        },
        onChange: onSeek
    }, rest));
};
/* harmony default export */ var video_player_ProgressBar = (ProgressBar);

;// CONCATENATED MODULE: ./hooks/useDoubleTap.ts

/**
 * Detect double taps
 * @param callback function to be called on double tap
 * @param delay detection time between taps
 * @returns 
 */ var useDoubleTap = function(callback) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300;
    var ref = (0,react.useState)(0), tap = ref[0], setTap = ref[1];
    var handleTap = function() {
        var now = Date.now();
        var delta = now - tap;
        if (delta < delay && delta > 0) {
            callback();
        }
        setTap(now);
    };
    return handleTap;
};
/* harmony default export */ var hooks_useDoubleTap = (useDoubleTap);

;// CONCATENATED MODULE: ./blocks/MylerSection/components/video-player/utils.ts
var formatDuration = function() {
    var seconds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var date = new Date(seconds * 1000);
    // const hours = date.getUTCHours();
    var minutes = date.getUTCMinutes();
    var formattedTime = "".concat(minutes.toString().padStart(2, "0"), ":").concat(date.getUTCSeconds().toString().padStart(2, "0"));
    return formattedTime;
};

;// CONCATENATED MODULE: ./blocks/MylerSection/icons/FullscreenToggle.tsx

var FullscreenToggle = function(param) {
    var className = param.className, _toggle = param.toggle, toggle = _toggle === void 0 ? true : _toggle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: !toggle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            className: className,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M4 9L4 6C4 4.89543 4.89543 4 6 4L9 4",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M20 15V18C20 19.1046 19.1046 20 18 20H15",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15 4L18 4C19.1046 4 20 4.89543 20 6L20 9",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M9 20L6 20C4.89543 20 4 19.1046 4 18L4 15",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            className: className,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M9 4V7C9 8.10457 8.10457 9 7 9H4",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15 20L15 17C15 15.8954 15.8954 15 17 15L20 15",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M20 9L17 9C15.8954 9 15 8.10457 15 7L15 4",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M4 15L7 15C8.10457 15 9 15.8954 9 17L9 20",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
/* harmony default export */ var icons_FullscreenToggle = (FullscreenToggle);

;// CONCATENATED MODULE: ./blocks/MylerSection/components/video-player/VideoPlayer.tsx

















var VideoPlayer = function(_param) {
    var src = _param.src, thumbnail = _param.thumbnail, _muted = _param.muted, muted = _muted === void 0 ? false : _muted, _autoPlay = _param.autoPlay, autoPlay = _autoPlay === void 0 ? false : _autoPlay, _formats = _param.formats, formats = _formats === void 0 ? [
        "video/mp4"
    ] : _formats, _controlsTs = _param.controlsTs, controlsTs = _controlsTs === void 0 ? 3000 : _controlsTs, _isMobile = _param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "thumbnail",
        "muted",
        "autoPlay",
        "formats",
        "controlsTs",
        "isMobile"
    ]);
    var ref;
    var videoRef = (0,react.useRef)(null);
    var timeoutRef = (0,react.useRef)(0);
    var ref1 = (0,react.useState)(0), playTime = ref1[0], setPlayTime = ref1[1];
    var ref2 = (0,react.useState)(muted), mute = ref2[0], setMute = ref2[1];
    var ref3 = (0,react.useState)(0), percentage = ref3[0], setPercentage = ref3[1];
    var ref4 = (0,react.useState)(true), showControls = ref4[0], setShowControls = ref4[1];
    var ref5 = (0,react.useState)(false), showTimer = ref5[0], setShowTimer = ref5[1];
    var getDuration = function() {
        var video = videoRef.current;
        if (!video) return "0";
        return formatDuration(video.duration);
    };
    var handlePlay = (0,react.useCallback)(function() {
        var video = videoRef.current;
        if (video.paused) {
            video.play();
        } else if (video) {
            video.pause();
        }
    }, []);
    var handleMute = (0,react.useCallback)(function() {
        var video = videoRef.current;
        video.muted = !mute;
        setMute(!mute);
    }, [
        mute
    ]);
    var handleControlsOverlay = (0,react.useCallback)(function() {
        setShowControls(true);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(function() {
            setShowControls(false);
        }, controlsTs);
    }, [
        controlsTs
    ]);
    var handleDurationUpdate = (0,react.useCallback)(function() {
        setPlayTime(videoRef.current.currentTime);
        setPercentage(videoRef.current.currentTime / videoRef.current.duration * 100);
    }, []);
    var handleVideoEnded = (0,react.useCallback)(function() {
        videoRef.current.pause();
        setPercentage(0);
        setPlayTime(0);
    }, []);
    var handleVideoPlaying = (0,react.useCallback)(function() {
        handleControlsOverlay();
    }, [
        handleControlsOverlay
    ]);
    var toggleFullScreen = function() {
        var video = videoRef.current;
        if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
        } else {
            video.requestFullscreen({
                navigationUI: "show"
            });
        }
    };
    var handleFullScreen = (0,react.useCallback)(function() {
        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else {
            toggleFullScreen();
        }
    }, []);
    // video element event listeners
    (0,react.useEffect)(function() {
        var video = videoRef.current;
        video.addEventListener("timeupdate", handleDurationUpdate, false);
        video.addEventListener("ended", handleVideoEnded, false);
        video.addEventListener("playing", handleVideoPlaying, false);
        return function() {
            video.removeEventListener("timeupdate", handleDurationUpdate, false);
            video.removeEventListener("ended", handleVideoEnded, false);
            video.removeEventListener("playing", handleVideoPlaying, false);
        };
    }, [
        handleDurationUpdate,
        handleVideoEnded,
        handleVideoPlaying
    ]);
    // clean up
    (0,react.useEffect)(function() {
        return function() {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    var handleSeek = function(e) {
        var video = videoRef.current;
        video.currentTime = video.duration / 100 * Number(e.target.value);
        setPercentage(Number(e.target.value));
    };
    // double tap to fullscreen on mobile
    var handleDoubleTap = hooks_useDoubleTap(handleFullScreen);
    var mobileProps = isMobile ? {
        onTouchStart: handleDoubleTap,
        onDoubleClick: handleDoubleTap
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        as: "figure",
        className: (VideoPlayer_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: videoRef,
                onClick: function() {
                    handleControlsOverlay();
                    handlePlay();
                },
                autoPlay: autoPlay,
                muted: mute,
                poster: thumbnail,
                playsInline: true
            }, mobileProps, rest), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        src: src,
                        type: formats.join(",")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            width: "100%",
                            background: "white"
                        }
                    })
                ]
            })),
            showControls && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (VideoPlayer_module_default()).progressInfo,
                        children: [
                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseButton/* default */.Z, {
                                className: (VideoPlayer_module_default()).fullScreen,
                                onClick: handleFullScreen,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_FullscreenToggle, {
                                    toggle: false
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Body */.uT, {
                                color: "white",
                                align: "right",
                                children: [
                                    formatDuration(playTime),
                                    " / ",
                                    getDuration()
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (VideoPlayer_module_default()).progressContainer,
                                children: [
                                    showTimer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (VideoPlayer_module_default()).timerInfo,
                                        style: {
                                            left: "calc(".concat(percentage, "% - 25px)")
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Small */.x4, {
                                            xs: false,
                                            children: formatDuration(playTime)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(video_player_ProgressBar, {
                                        max: 100,
                                        currentTime: percentage,
                                        onSeek: handleSeek,
                                        onMouseEnter: function() {
                                            return setShowTimer(true);
                                        },
                                        onMouseLeave: function() {
                                            return setShowTimer(false);
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (VideoPlayer_module_default()).controlButtons,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseButton/* default */.Z, {
                                onClick: handlePlay,
                                className: (VideoPlayer_module_default()).playPause,
                                children: videoRef.current && !((ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.paused) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Pause, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_PlayButton, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseButton/* default */.Z, {
                                onClick: handleMute,
                                className: (VideoPlayer_module_default()).muteSound,
                                children: videoRef.current && videoRef.current.muted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Mute, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Sound, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var video_player_VideoPlayer = (VideoPlayer);

;// CONCATENATED MODULE: ./blocks/MylerSection/components/video-player/index.tsx


;// CONCATENATED MODULE: ./blocks/MylerSection/index.tsx

















var MylerSection = function() {
    var ref = (0,react.useState)(false), openForm = ref[0], setOpenForm = ref[1];
    var ref1 = (0,react.useState)(false), openInfoForm = ref1[0], setOpenInfoForm = ref1[1];
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width: 768px)");
    var scrollToPageSection = function(id) {
        var section = document.getElementById(id);
        if (!section) return;
        section === null || section === void 0 ? void 0 : section.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        });
    };
    var handleOpenEnquiryForm = function() {
        setOpenForm(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "myler-section-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "myler-section-coverContainer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: myler_cover,
                    alt: "Myler discover page main cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "myler-section-overlay",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                        as: "h1",
                        className: "myler-section-mainHeading",
                        color: "white",
                        children: "Discover MyLER"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                        as: "h2",
                        className: "myler-section-subHeading",
                        color: "white",
                        children: "The future of the Independent Travel Agent"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Navigation, {
                scrollToSection: scrollToPageSection
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_About, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(video_player_VideoPlayer, {
                src: "https://d13bre0qp8legl.cloudfront.net/videos/myler-hero.mov",
                muted: true,
                autoPlay: true,
                isMobile: isMobile
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Why, {
                handleOpenEnquiryForm: handleOpenEnquiryForm
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Resources, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Hotels, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "enquire-testimonial",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Enquire, {
                        handleOpenEnquiryForm: handleOpenEnquiryForm
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Testimonials, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Faq, {
                handleOpenEnquiryForm: handleOpenEnquiryForm
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(enquiry_form_EnquiryFormContainer, {
                open: openForm,
                handleFormClose: function() {
                    return setOpenForm(false);
                },
                onSubmitSuccess: function() {
                    setOpenInfoForm(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InfoDialog, {
                open: openInfoForm,
                title: "Thank you",
                subHeading: "Your enquiry has been sent",
                handleClose: function() {
                    setOpenInfoForm(false);
                }
            })
        ]
    });
};
/* harmony default export */ var blocks_MylerSection = (MylerSection);

;// CONCATENATED MODULE: ./pages/independent-travel-agent/index.tsx






var Myler = function(param) {
    var globalLayoutProps = param.globalLayoutProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GlobalLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalLayoutProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(blocks_MylerSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadApp/* default */.Z, {})
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ var independent_travel_agent = (Myler);


/***/ }),

/***/ 28461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ getDefaults; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45901);



function getDefaults(schema) {
    // Check if it's a ZodEffect
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(schema, zod__WEBPACK_IMPORTED_MODULE_1__/* .ZodEffects */ .Xc)) {
        // Check if it's a recursive ZodEffect
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(schema.innerType(), zod__WEBPACK_IMPORTED_MODULE_1__/* .ZodEffects */ .Xc)) return getDefaults(schema.innerType());
        // return schema inner shape as a fresh zodObject
        return getDefaults(zod__WEBPACK_IMPORTED_MODULE_1__/* .ZodObject.create */ .CQ.create(schema.innerType().shape));
    }
    function getDefaultValue(schema) {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(schema, zod__WEBPACK_IMPORTED_MODULE_1__/* .ZodDefault */ .uE)) return schema._def.defaultValue();
        // return an empty array if it is
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(schema, zod__WEBPACK_IMPORTED_MODULE_1__/* .ZodArray */ .p5)) return [];
        // return an empty string if it is
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(schema, zod__WEBPACK_IMPORTED_MODULE_1__/* .ZodString */ .$T)) return "";
        // return an content of object recursively
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(schema, zod__WEBPACK_IMPORTED_MODULE_1__/* .ZodObject */ .CQ)) return getDefaults(schema);
        if (!("innerType" in schema._def)) return undefined;
        return getDefaultValue(schema._def.innerType);
    }
    return Object.fromEntries(Object.entries(schema.shape).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        return [
            key,
            getDefaultValue(value)
        ];
    }));
}


/***/ }),

/***/ 78863:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Faq_container__KBEw9","faqList":"Faq_faqList__E4gK0","enquiryFormLink":"Faq_enquiryFormLink__uA4aY"};

/***/ }),

/***/ 84135:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoDialog_container__pr2ts","closeIconWrapper":"InfoDialog_closeIconWrapper__sIma2","closeIcon":"InfoDialog_closeIcon__4YcbS","logo":"InfoDialog_logo__8nZkx","subHeading":"InfoDialog_subHeading__YUs_p"};

/***/ }),

/***/ 37849:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Testimonial_container__9fDWI","wrapper":"Testimonial_wrapper__KZC3M","questionMark":"Testimonial_questionMark__E_6Iv","testimonialWrapper":"Testimonial_testimonialWrapper__oRj5z","testimonialName":"Testimonial_testimonialName__5ySk2","tier":"Testimonial_tier__inrkn","navPosition":"Testimonial_navPosition__ZI6tF"};

/***/ }),

/***/ 14533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"errorMsg":"ReferralChannel_errorMsg__GO2go"};

/***/ }),

/***/ 83901:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ToggleInput_container__65SE8","headerSection":"ToggleInput_headerSection__8bFXh","switch":"ToggleInput_switch__gpbPB","content":"ToggleInput_content__SEsGh","contentOpen":"ToggleInput_contentOpen__evGeE"};

/***/ }),

/***/ 85647:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"range":"ProgressBar_range__b9Qdx"};

/***/ }),

/***/ 58252:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoPlayer_container__XOU6x","controls":"VideoPlayer_controls__MQ2YY","controlButtons":"VideoPlayer_controlButtons__uhuyV","playPause":"VideoPlayer_playPause__I6HPI","muteSound":"VideoPlayer_muteSound__UBlrj","circleBackground":"VideoPlayer_circleBackground__wFuNn","progressInfo":"VideoPlayer_progressInfo__QmjU9","progressContainer":"VideoPlayer_progressContainer__0jPT4","timerInfo":"VideoPlayer_timerInfo__txnR_","pointer":"VideoPlayer_pointer__1f4Mc","fullScreen":"VideoPlayer_fullScreen__V1Fqb"};

/***/ }),

/***/ 49323:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialog":"EnquiryForm_dialog__pq3sM","container":"EnquiryForm_container__GwYSM","headerSection":"EnquiryForm_headerSection__h2P9o","subheading":"EnquiryForm_subheading__Sx3Ge","form":"EnquiryForm_form__f04gd","enquireBtnWrapper":"EnquiryForm_enquireBtnWrapper__dD7tT","enquireBtn":"EnquiryForm_enquireBtn__sYvQb","switch":"EnquiryForm_switch__MB1qW","closeBtn":"EnquiryForm_closeBtn__kYW5z","closeBtnWrapper":"EnquiryForm_closeBtnWrapper__EoG5H","closeIcon":"EnquiryForm_closeIcon__CVFYV","switchWrapper":"EnquiryForm_switchWrapper__q3ioP","iataType":"EnquiryForm_iataType__mqBj_"};

/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 48228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ useMutation; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/mutation.mjs
var mutation = __webpack_require__(89886);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(30081);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(33989);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/mutationObserver.mjs





// CLASS
class MutationObserver extends subscribable/* Subscribable */.l {
  constructor(client, options) {
    super();
    this.client = client;
    this.setOptions(options);
    this.bindMethods();
    this.updateResult();
  }

  bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  }

  setOptions(options) {
    var _this$currentMutation;

    const prevOptions = this.options;
    this.options = this.client.defaultMutationOptions(options);

    if (!(0,utils/* shallowEqualObjects */.VS)(prevOptions, this.options)) {
      this.client.getMutationCache().notify({
        type: 'observerOptionsUpdated',
        mutation: this.currentMutation,
        observer: this
      });
    }

    (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.setOptions(this.options);
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$currentMutation2;

      (_this$currentMutation2 = this.currentMutation) == null ? void 0 : _this$currentMutation2.removeObserver(this);
    }
  }

  onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    const notifyOptions = {
      listeners: true
    };

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.notify(notifyOptions);
  }

  getCurrentResult() {
    return this.currentResult;
  }

  reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  }

  mutate(variables, options) {
    this.mutateOptions = options;

    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }

    this.currentMutation = this.client.getMutationCache().build(this.client, { ...this.options,
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    });
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  }

  updateResult() {
    const state = this.currentMutation ? this.currentMutation.state : (0,mutation/* getDefaultState */.R)();
    const isLoading = state.status === 'loading';
    const result = { ...state,
      isLoading,
      isPending: isLoading,
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    };
    this.currentResult = result;
  }

  notify(options) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      // First trigger the mutate callbacks
      if (this.mutateOptions && this.hasListeners()) {
        if (options.onSuccess) {
          var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;

          (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null ? void 0 : _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
          (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null ? void 0 : _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
        } else if (options.onError) {
          var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;

          (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null ? void 0 : _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
          (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null ? void 0 : _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
        }
      } // Then trigger the listeners


      if (options.listeners) {
        this.listeners.forEach(({
          listener
        }) => {
          listener(this.currentResult);
        });
      }
    });
  }

}


//# sourceMappingURL=mutationObserver.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useSyncExternalStore.mjs
var useSyncExternalStore = __webpack_require__(464);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/utils.mjs
var lib_utils = __webpack_require__(24798);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs
'use client';






function useMutation(arg1, arg2, arg3) {
  const options = (0,utils/* parseMutationArgs */.lV)(arg1, arg2, arg3);
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)({
    context: options.context
  });
  const [observer] = react.useState(() => new MutationObserver(queryClient, options));
  react.useEffect(() => {
    observer.setOptions(options);
  }, [observer, options]);
  const result = (0,useSyncExternalStore/* useSyncExternalStore */.$)(react.useCallback(onStoreChange => observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange)), [observer]), () => observer.getCurrentResult(), () => observer.getCurrentResult());
  const mutate = react.useCallback((variables, mutateOptions) => {
    observer.mutate(variables, mutateOptions).catch(noop);
  }, [observer]);

  if (result.error && (0,lib_utils/* shouldThrowError */.L)(observer.options.useErrorBoundary, [result.error])) {
    throw result.error;
  }

  return { ...result,
    mutate,
    mutateAsync: result.mutate
  };
} // eslint-disable-next-line @typescript-eslint/no-empty-function

function noop() {}


//# sourceMappingURL=useMutation.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6319,7295,5675,5901,1608,5156,1657,1736,2567,6492,2334,2083,6312,9565,4520,5989,9510,6343,3021,9774,2888,179], function() { return __webpack_exec__(59937); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);